import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import {
  authBootstrap,
  authLogin,
  authMe,
  authRegister,
  authLogout,
} from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);          // user object
  const [loading, setLoading] = useState(true);    // first-load check
  const [hasUsers, setHasUsers] = useState(true);  // bootstrap state

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("qc_token");
    if (!token) {
      setUser(null);
      try {
        const b = await authBootstrap();
        setHasUsers(b.has_users);
      } catch {
        setHasUsers(true);
      }
      setLoading(false);
      return;
    }
    try {
      const me = await authMe();
      setUser(me);
      setHasUsers(true);
    } catch {
      localStorage.removeItem("qc_token");
      setUser(null);
      try {
        const b = await authBootstrap();
        setHasUsers(b.has_users);
      } catch {
        setHasUsers(true);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onUnauth = () => {
      setUser(null);
    };
    window.addEventListener("qc-unauth", onUnauth);
    return () => window.removeEventListener("qc-unauth", onUnauth);
  }, [refresh]);

  const login = async (email, password) => {
    const res = await authLogin(email, password);
    localStorage.setItem("qc_token", res.token);
    localStorage.setItem("qc_operator_name", res.user.name || "Admin");
    setUser(res.user);
    setHasUsers(true);
    return res.user;
  };

  const register = async (email, password, name) => {
    const res = await authRegister(email, password, name);
    localStorage.setItem("qc_token", res.token);
    localStorage.setItem("qc_operator_name", res.user.name || "Admin");
    setUser(res.user);
    setHasUsers(true);
    return res.user;
  };

  const logout = async () => {
    try {
      await authLogout();
    } catch {
      /* ignore */
    }
    localStorage.removeItem("qc_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, loading, hasUsers, login, register, logout, refresh, isAdmin: user?.role === "admin" }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
